import React, { useEffect, useCallback } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { Container, Typography, CircularProgress, Alert, AlertTitle, Box, Paper } from '@mui/material';
import useAuth from '../hooks/useAuth';
import { Navigate, useLocation } from 'react-router-dom';

const Login = ({ onSuccess }) => {
  const { ctxUser, checkLogin, doLogin, loading } = useAuth(onSuccess);
  const location = useLocation();
  
  const handleLoginSuccess = (response) => {
    const token = response.credential;
    doFdvBancLogin(token);
  };

  const doFdvBancLogin = useCallback((token) => {
    doLogin(token);
  }, [doLogin]);
  
  useEffect(() => {
    const loginStatus = checkLogin();
    if(loginStatus.status) {
      doFdvBancLogin(loginStatus.token);
    }
  }, [doFdvBancLogin, checkLogin]);

  const isUnauthorized = ctxUser?.error && (
    ctxUser.error.response?.status === 401 || ctxUser.error.status === 401
  );

  const errorMessage = ctxUser?.error?.response?.data?.message || 
    (typeof ctxUser?.error?.response?.data === 'string' ? ctxUser?.error?.response?.data : null);

  const userEmail = ctxUser?.decodedToken?.email;

  return (
    <Container maxWidth="sm" sx={{ marginTop: '50px' }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center', borderRadius: 2 }}>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, color: '#1976d2', mb: 3 }}>
          FDV Banc - Login
        </Typography>

        { loading ? (      
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 4 }}>
            <CircularProgress size={50} />
            <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
              Autenticant amb FDV Banc...
            </Typography>
          </Box>
        ) : (
          <>
            {ctxUser?.error && (
              <Alert severity="error" sx={{ my: 3, textAlign: 'left' }}>
                <AlertTitle sx={{ fontWeight: 'bold' }}>
                  {isUnauthorized ? 'Accés no autoritzat' : "Error d'autenticació"}
                </AlertTitle>
                {isUnauthorized ? (
                  errorMessage || (
                    userEmail 
                      ? `L'usuari (${userEmail}) no està autoritzat a FDV Banc. Contacta amb l'administrador per sol·licitar accés.`
                      : "Aquest compte de Google no està autoritzat a FDV Banc. Contacta amb l'administrador per sol·licitar accés."
                  )
                ) : (
                  errorMessage || "S'ha produït un error en connectar amb el servidor. Si us plau, torna-ho a provar."
                )}
              </Alert>
            )}

            {(ctxUser?.isAuthenticated && location.pathname === '/login') && (
              <Navigate to="/" replace />
            )}

            {!ctxUser?.isAuthenticated && (
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2 }}>
                <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                  Inicia sessió amb el teu compte de Google:
                </Typography>
                <GoogleLogin
                  onSuccess={handleLoginSuccess}
                  useOneTap={false}
                  onError={() => {
                    console.error('Google Login Failed');
                  }}
                />
              </Box>
            )}
          </>
        )}
      </Paper>
    </Container>
  );
};

export default Login;